import { reactive } from 'vue'
import { findHotelList } from '@/api/room'
import moment from 'moment'

export default function getHotel() {
    const hotelList = reactive([])

    const findHotelListAll = async () => {
        const { list } = await findHotelList({ page: 1, size: 1000 })
        hotelList.length = 0
        hotelList.push(...list)
    }

    findHotelListAll()

    return {
        hotelList
    }
}